// Converts the first character of a string into uppercase
export const capitalize = str => typeof str === "string" && str.charAt(0).toUpperCase() + str.slice(1);

// Returns valid placeholder for Search bar if text does not exist in i18n.js
export const getSearchPlaceholder = (searchBarPlaceholderText, translate) => {
    let placeholderText = searchBarPlaceholderText;

    // Check if the placeholder is one of the default values
    if (['Search', 'Search the web...', 'Search the web'].includes(searchBarPlaceholderText)) {
        placeholderText = translate('Home.Search the web');
    } else {
        // Attempt to translate the placeholder text
        const translationKey = `Search.${searchBarPlaceholderText}`;
        const translatedText = translate(translationKey);
        if (translatedText !== translationKey) {
            placeholderText = translatedText;
        }
    }

    return placeholderText;
}
